module.exports = __webpack_public_path__ + "static/media/shaun-tjie-200x200.4ee52574.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/page/company/advisors/images/shaun-tjie-200x200.jpg
// module id = 1780
// module chunks = 147